import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { StorageProvider } from '../../providers/storage/storage';
import { LocalfileProvider } from '../../providers/localfile/localfile';
import { Localfile } from '../../interfaces/localfile.modal';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-local-files',
  templateUrl: 'local-files.html',
})
export class LocalFilesPage {

  localfiles: Localfile[];
  displayAsList: boolean;
  filterType: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public localfileService: LocalfileProvider, public storageService: StorageProvider) {
    this.filterType = "asc";
    this.localfiles = [];
  }

  ionViewDidLoad() {
    this.getLocalFiles();
    this.getDisplayListView();
  }

  getLocalFiles(){
    this.localfileService.getLocalFiles()
    .then(localfiles => {
      this.localfiles = localfiles;
    }).catch(error => {
      console.log('error to getLocalFiles'+ error);
    });
  }

  getDisplayListView(){
    this.storageService.getDataStorage("displayAsList").then(displayListView => {
      if(displayListView !== null){
        this.displayAsList = displayListView;
      } else {
        this.displayAsList = false;
      }
    });
  }

  updateListView(){
    this.displayAsList = !this.displayAsList;
    this.storageService.setDataStorage("displayAsList", this.displayAsList);
  }

}



// WEBPACK FOOTER //
// ./src/pages/local-files/local-files.ts